export default __webpack_public_path__ + "static/media/extensions-hero.6e1d4027.jpg";